
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { TreeNode, NodeType } from '@/modules/nomenclature/models/treeNode';

@Component({
  components: {}
})
export default class LocationForm extends Vue {
  @Prop({ required: true })
  protected value!: TreeNode;
  @Prop({ required: true })
  protected saveCallBack!: (location: TreeNode, oldLocation: TreeNode) => Promise<void>;
  protected sendingRequest = false;
  protected requestError = false;
  protected input?: TreeNode;
  protected icons = [
    {
      value: 'mdi-map-marker-outline',
      name: this.$i18n.t('nomenclature.LocationForm.mapLabel').toString()
    },
    {
      value: 'mdi-domain',
      name: this.$i18n.t('nomenclature.LocationForm.domainLabel').toString()
    },
    {
      value: 'mdi-garage',
      name: this.$i18n.t('nomenclature.LocationForm.garageLabel').toString()
    },
    {
      value: 'mdi-office-building',
      name: this.$i18n.t('nomenclature.LocationForm.buildingLabel').toString()
    },
    {
      value: 'mdi-home',
      name: this.$i18n.t('nomenclature.LocationForm.homeLabel').toString()
    },
    {
      value: 'mdi-door-closed',
      name: this.$i18n.t('nomenclature.LocationForm.doorLabel').toString()
    },
    {
      value: 'mdi-pine-tree',
      name: this.$i18n.t('nomenclature.LocationForm.pineTreeLabel').toString()
    }
  ];

  protected created(): void {
    this.presetInput(this.value);
  }

  @Watch('value', { immediate: true })
  protected presetInput(value: TreeNode): void {
    if (value.nodeType === NodeType.VIRTUAL) {
      this.input = {
        id: undefined,
        name: '',
        trigram: '',
        icon: 'mdi-map-marker-outline',
        isLeaf: value.isLeaf,
        parentId: value.parentId,
        children: [],
        nodeType: NodeType.LOCATION,
        depth: value.depth
      };
    } else {
      this.input = {
        id: value.id,
        name: value.name,
        trigram: value.trigram,
        icon: value.icon,
        isLeaf: value.isLeaf,
        parentId: value.parentId,
        children: value.children,
        nodeType: value.nodeType,
        depth: value.depth
      };
    }
  }

  protected validate(): void {
    const isValid = (this.$refs.form as HTMLFormElement).validate();
    if (isValid && this.input?.trigram) {
      this.input.trigram = this.input.trigram.toUpperCase();
      this.sendingRequest = true;
      setTimeout(() => {
        if (this.input) {
          this.saveCallBack(this.input, this.value)
            .then(() => {
              this.$emit('cancel');
            })
            .catch(() => (this.requestError = true))
            .finally(() => (this.sendingRequest = false));
        }
      }, 500);
    }
  }

  protected get NodeType(): Record<string, string> {
    return NodeType;
  }
}
